import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {DataTableModule} from "../../components/common/datatables/datatable.module";
import {PipesModule} from "../../pipes/pipes.module";
import {ClientStatusModule} from "../client-status/client-status.module";
import {ClientsService} from "../../models/clients/clients.service";
import {PricingsService} from "../../models/pricings/pricings.service";
import {PricingTableComponent} from "./pricing-table.component";
import {BadgesHelper} from '../../services/BadgesHelper';
import {ScheduledCallbacksModule} from "../scheduled-callbacks/scheduled-callbacks.module";
import {ClientNotesModule} from "../../modules/client-notes/client-notes.module";

@NgModule({
    declarations: [
        PricingTableComponent,
    ],
    imports: [
        CommonModule,
        DataTableModule,
        PipesModule,
        ClientStatusModule,
        ScheduledCallbacksModule,
        ClientNotesModule,
    ],
    exports: [
        PricingTableComponent,
    ],
    providers: [
        ClientsService,
        PricingsService,
        BadgesHelper
    ]
})

export class PricingTableModule {
}

 


// WEBPACK FOOTER //
// ./src/app/modules/pricing-table/pricing-table.module.ts